import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  portsData: [],
  portsLogLink: {},
  sharedPortData: [],
  sharedSlaveData: [],
  settingData: null,
  settingOriginal: null,
  configData: null,
  promise: {},
  sharedPromise: {},
  historyPromise: {},
  settingTarget: null,
  highlightList: [],
  settingPopup: null,
  settingView: false,
  historyData: {},
  pendingValidation: false,
  pendingHourlyRequests: {},
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
